/**
 * @param {object} params
 * @param {number} params.postId
 * @param {import("@raiden/library/types/common/TranslatedField").TranslatedField} params.postSlug
 * @param {import("@raiden/library/hooks/useTranslate").Translate} params.translate
 * @returns {string}
 */
export function getPostSlug({ postId, postSlug, translate }) {
  return `${postId}-${translate(postSlug)}`;
}
